class OrderManagementController {
    constructor($scope, orderManagementService) {
        this.orderManagement = orderManagementService;

        $scope.$on('order-change', () => {
            this.invalidate();
            this.toggleOrderManagement();
        });
        $scope.$on('order-cancel', () => {
            this.invalidate();
        });
    }

    $onInit() {
        if (!this.orderManagement.orders) {
            this.orderManagement.getOrders();
        }
    }

    invalidate() {
        this.orderManagement.invalidate();
        this.orderManagement.getOrders();
    }
}

const orderManagementComponentDefinition = {
    bindings: {
        toggleOrderManagement: '&',
    },
    controller: ['$scope', 'OrderManagementService', OrderManagementController],
    template: require('./order-management.component.html').trim(),
};

module.exports = {
    OrderManagementController,
    orderManagementComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/order/ordermanagement/order-management.component.js